import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  addToHistory,
  goBack,
  setPath,
  setTeamsAuthorize,
} from './teamsChannelSlice'
import {
  fetchToken,
  getRelativeItemPath,
  setLocalStorageItem,
} from '../../utils/helper'
import { app } from '@microsoft/teams-js'
import { getTeamsChannelData } from '../../service/sharedDrive/teamsChannel'
import { uploadToChannel } from '../../service/sharedDrive/saveToChannels'
import { oneDriveNotification } from '../notification/action'
import { saveToChannelsAndReplace } from '../../service/sharedDrive/saveToChannelsAndReplace'

export const fetchItemsForPath =
  (teamsUserCredential, teamId, channelId, itemId, name, path) =>
  async (dispatch) => {
    dispatch(addToHistory({ teamId, channelId, itemId, name, path }))
    dispatch(setPath({ teamId, channelId, itemId, name, path }))
    const res = await dispatch(
      getTeamsShared({ teamsUserCredential, teamId, channelId, itemId })
    )
    if (getTeamsShared.rejected.match(res)) {
      // await dispatch(updateReadWriteField({ isReadFiles: false }))
      // // res.payload &&
      // //   !res.payload.includes('Azure.Iden') &&
      // dispatch(
      //   errorHandler({
      //     message:
      //       'Your permissions are not yet updated. Please check your permissions and try again.',
      //   })
      // )
    }
  }
export const breadCrumbNavigate =
  (teamsUserCredential, teamId, channelId, itemId, index, name, path) =>
  async (dispatch) => {
    dispatch(
      goBack({
        channelId,
        teamId,
        itemId,
        index,
        name,
        path,
      })
    )
    const res = await dispatch(
      getTeamsShared({ teamsUserCredential, teamId, channelId, itemId })
    )
    if (getTeamsShared.rejected.match(res)) {
      // await dispatch(updateReadWriteField({ isReadFiles: false }))
      // // res.payload &&
      // //   !res.payload.includes('Azure.Iden') &&
      // dispatch(
      //   errorHandler({
      //     message:
      //       'Your permissions are not yet updated. Please check your permissions and try again.',
      //   })
      // )
    }
  }

export const getTeamsAuthorize = createAsyncThunk(
  'teamsChannel/getTeamsAuthorize',
  async ({ teamsUserCredential }, { rejectWithValue, getState, dispatch }) => {
    try {
      if (!teamsUserCredential) {
        throw new Error('TeamsFx SDK is not initialized.')
      }
      await teamsUserCredential.login([
        'User.Read',
        'Files.ReadWrite.All',
        // 'Sites.Read.All',
        'Team.ReadBasic.All',
        'Channel.ReadBasic.All',
      ])
      dispatch(setTeamsAuthorize(true))
      setLocalStorageItem('teamsChannelConsent', true)
      await dispatch(getTeamsShared({ teamsUserCredential }))
      return true
    } catch (error) {
      dispatch(setTeamsAuthorize(false))
      setLocalStorageItem('teamsChannelConsent', false)
      return false
    }
  }
)

export const getTeamsShared = createAsyncThunk(
  'teamsChannel/getTeamsChannelData',
  async (
    { teamsUserCredential, teamId, channelId, itemId },
    { rejectWithValue, getState, dispatch, fulfillWithValue }
  ) => {
    try {
      const token = await fetchToken(teamsUserCredential)
      const teamsContext = await app.getContext()
      const teamsChannel = await getTeamsChannelData(
        token,
        teamsContext.user.tenant.id,
        teamId,
        channelId,
        itemId
      )

      return fulfillWithValue(teamsChannel)
    } catch (error) {
      throw error
    }
  }
)
export const channelFileUpload = createAsyncThunk(
  'teamsChannel/channelFileUpload',
  async (
    { teamsUserCredential, name, docBlobRef, size },
    { rejectWithValue, getState, dispatch }
  ) => {
    try {
      const { teamsChannel } = getState()
      const { history } = teamsChannel
      const index = history.length ? history.length - 1 : 0
      const lastHistory = history[index]

      const token = await fetchToken(teamsUserCredential)
      const teamsContext = await app.getContext()
      const data = await uploadToChannel(
        token,
        teamsContext.user.tenant.id,
        lastHistory?.teamId,
        lastHistory?.channelId,
        lastHistory?.path
          ? getRelativeItemPath(lastHistory.path) +
              '/' +
              lastHistory.name +
              '/' +
              name
          : name,
        docBlobRef,
        name
      )

      await dispatch(
        breadCrumbNavigate(
          teamsUserCredential,
          lastHistory.teamId,
          lastHistory.channelId,
          lastHistory.itemId,
          index,
          lastHistory.name,
          lastHistory.path
        )
      )
      dispatch(
        oneDriveNotification({
          name: name,
          size: size,
          itemId: data.itemId,
          isNotification: true,
          isTeamsChannel: true,
        })
      )

      return data
    } catch (error) {
      throw error
    }
  }
)
export const channelFileUploadAndReplace = createAsyncThunk(
  'teamsChannel/channelFileUploadAndReplace',
  async (
    { teamsUserCredential, name, docBlobRef, size },
    { rejectWithValue, getState, dispatch }
  ) => {
    try {
      const { teamsChannel } = getState()
      const { history } = teamsChannel
      const index = history.length ? history.length - 1 : 0
      const lastHistory = history[index]

      const token = await fetchToken(teamsUserCredential)
      const teamsContext = await app.getContext()
      const data = await saveToChannelsAndReplace(
        token,
        teamsContext.user.tenant.id,
        lastHistory?.teamId,
        lastHistory?.channelId,
        lastHistory?.path
          ? getRelativeItemPath(lastHistory.path) +
              '/' +
              lastHistory.name +
              '/' +
              name
          : name,
        docBlobRef,
        name
      )

      await dispatch(
        breadCrumbNavigate(
          teamsUserCredential,
          lastHistory.teamId,
          lastHistory.channelId,
          lastHistory.itemId,
          index,
          lastHistory.name,
          lastHistory.path
        )
      )
      dispatch(
        oneDriveNotification({
          name: name,
          size: size,
          itemId: data.itemId,
          isNotification: true,
          isTeamsChannel: true,
        })
      )

      return data
    } catch (error) {
      throw error
    }
  }
)
